import { render, staticRenderFns } from "./WhatsappBroadcastCancelled.vue?vue&type=template&id=e98e710e&scoped=true"
import script from "./WhatsappBroadcastCancelled.vue?vue&type=script&lang=js"
export * from "./WhatsappBroadcastCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98e710e",
  null
  
)

export default component.exports